import { createContext } from "react";
import nl_BE from "../lang/Language.nl-BE.json";
import documents_nl_BE from "../lang/Language.documents.nl-BE.json";

export const dictionaryList: any = { nl_BE };
export const languageList: any = { documents_nl_BE };

export const LanguageContext = createContext({
  language: "nl-BE",
  dictionary: dictionaryList,
});

export const DocumentContext = createContext({
  language: "documents-nl-BE",
  documentDictionary: languageList,
});
